function strengthToScore(
  connectionStrength?: 'Strong' | 'Medium' | 'Weak' | null,
): number {
  if (connectionStrength === 'Strong') return 65;
  if (connectionStrength === 'Medium') return 30;
  if (connectionStrength === 'Weak') return 1;
  return 0;
}

/**
 * Confidence score combining raw company connection score (0-100) and job fit with dynamic weights.
 * If raw score is missing, falls back to the minimum score for the known strength tier.
 */
export function calculateConfidenceScore(
  connectionScore: number | null | undefined,
  jobFit: 'high' | 'medium' | 'low' | null | undefined,
  networkWeight: number = 70,
  fitWeight: number = 30,
  connectionStrength?: 'Strong' | 'Medium' | 'Weak' | null,
): number | null {
  if (!jobFit) return null;

  const rawNetworkScore =
    typeof connectionScore === 'number' && !Number.isNaN(connectionScore)
      ? Math.max(0, Math.min(100, connectionScore))
      : strengthToScore(connectionStrength);

  const fitValues = { high: 100, medium: 60, low: 30 };
  const fitValue = fitValues[jobFit] ?? 0;

  return Math.round(rawNetworkScore * (networkWeight / 100) + fitValue * (fitWeight / 100));
}
